module.exports = __webpack_public_path__ + "static/media/phone-in-hand.75b22109.png";